import { useCallback } from 'react'

import filestack from 'common/filestack'
import type { PickerFileMetadata, PickerOptions } from 'common/filestack'

const FILE_PICKER_CONFIG: PickerOptions = {
  maxFiles: 1,
  disableDirectoryUpload: true,
  accept: ['image/png', 'image/jpeg', 'image/pjpeg'],
  transformations: { crop: { aspectRatio: 1, force: true } },
  fromSources: ['local_file_system', 'url', 'facebook', 'googledrive', 'dropbox', 'instagram'],
}

const getPickerStoreOptions = (scid: number): PickerOptions['storeTo'] => ({
  location: 'gcs',
  container: window.FILE_STACK_GCS_BUCKET_TARGET,
  path: `/college-content/${scid}/`,
})

export { PickerFileMetadata }

interface IUseImageUpload {
  scid: number
  setImageUploadOpen: (open: boolean) => void
  onPickImage: (image: PickerFileMetadata) => void
}

export const useImageUpload = ({ scid, onPickImage, setImageUploadOpen }: IUseImageUpload) => {
  if (!scid) {
    throw new Error('scid is required for image upload')
  }
  const onChooseImage = useCallback(
    (e) => {
      e.stopPropagation()
      setImageUploadOpen(true)
      filestack
        .pickAndStore({
          ...FILE_PICKER_CONFIG,
          storeTo: getPickerStoreOptions(scid),
        })
        .then(([picked]): void => {
          return onPickImage(picked)
        })
        // Covers both a failed upload and the user dismissing the picker.
        .catch(() => setImageUploadOpen(false))
    },
    [scid, setImageUploadOpen, onPickImage],
  )

  return onChooseImage
}
